import type { LensView } from '../types';

export const VIEW_CSP =
  "default-src 'none'; connect-src 'none'; img-src data:; font-src 'none'; style-src 'unsafe-inline'; script-src 'unsafe-inline'; object-src 'none'; frame-src 'none'; child-src 'none'; worker-src 'none'; base-uri 'none'; form-action 'none'";

export const KIT_CSS = `
:root { --rule: var(--hairline, #e8e4da); --hairline: #e8e4da; --ink: #0f0c08; --ink-2: #4a463f; --ink-3: #7a756b; --surface: #fff; --accent: var(--chart-1, #0f464f); --pos: #1e7a46; --neg: #b3261e; --warn: #a15c07; --muted: #a8a296; --tone-ink: var(--accent); --sans: "Suisse Int'l", helvetica, arial, sans-serif; color-scheme: light; }
* { box-sizing: border-box; }
html, body { background: transparent; }
body { margin: 0; font: 13px/1.35 var(--sans); color: var(--ink); font-variant-numeric: tabular-nums; }
.k-label { color: var(--ink-3); font-size: 12px; }
.k-value { font-size: 24px; font-weight: 500; line-height: 1.15; }
.k-fig { display: grid; gap: 2px; min-width: 0; }
.k-figs { display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 16px; }
.k-delta { font-size: 12px; color: var(--ink-3); white-space: nowrap; }
.k-delta.up { color: var(--pos); } .k-delta.down { color: var(--neg); }
.k-spark { display: block; overflow: visible; }
.k-good { color: var(--pos); } .k-bad { color: var(--neg); } .k-warn { color: var(--warn); } .k-muted { color: var(--muted); }
.k-row { display: flex; gap: 12px; align-items: baseline; }
.k-axis { fill: var(--ink-3); color: var(--ink-3); font-size: 11px; }
.k-grid { stroke: var(--hairline); }
`;

const RUNTIME = String.raw`
(function () {
  var channel = document.currentScript.getAttribute('data-channel');
  var drawFn = null, formatted = {}, formats = {}, received = false, derived = [], snapshot = false;
  var root = document.getElementById('lens-view');
  function post(type, payload) { window.parent.postMessage(Object.assign({ type: type, channel: channel }, payload || {}), '*'); }
  function fail(error) { post('lens:error', { message: String((error && error.message) || error) }); }
  function byFormat(value, format) {
    var size = Math.abs(value), sign = value < 0 ? '\u2212' : '';
    if (format === 'pct') return sign + (size * 100).toFixed(size < 0.01 ? 2 : 1) + '%';
    if (format === 'aud' || format === 'usd') {
      var symbol = format === 'aud' ? 'A$' : 'US$';
      if (size >= 1e9) return sign + symbol + (size / 1e9).toFixed(size >= 1e10 ? 1 : 2) + 'B';
      if (size >= 1e6) return sign + symbol + (size / 1e6).toFixed(size >= 1e8 ? 0 : size >= 1e7 ? 1 : 2) + 'M';
      if (size >= 1e4) return sign + symbol + (size / 1e3).toFixed(size >= 1e5 ? 0 : 1) + 'K';
      if (size >= 10) return sign + symbol + Math.round(size).toLocaleString('en-AU');
      return sign + symbol + size.toFixed(2);
    }
    if (format === 'num1' || format === 'days' || format === 'nights') return sign + size.toFixed(1);
    if (format === 'num2') return sign + size.toFixed(2);
    if (size >= 1e7) return sign + (size / 1e6).toFixed(1) + 'M';
    return sign + Math.round(size).toLocaleString('en-AU');
  }
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var FORMAT_NAMES = { aud: 1, usd: 1, pct: 1, int: 1, num1: 1, num2: 1, days: 1, nights: 1 };
  var NUMBER = /(A\$|US\$|\$)?[−-]?\d[\d,]*(\.\d+)?\s?(%|K\b|M\b|B\b)|(A\$|US\$|\$)[−-]?\d[\d,]*(\.\d+)?|\b\d{1,3}(,\d{3})+\b|\b\d+\.\d+\b/;
  function unsourced() {
    var found = [];
    [root, note].forEach(function (drawn) {
      if (!drawn) return;
      var walker = document.createTreeWalker(drawn, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        var node = walker.currentNode, text = node.nodeValue || '';
        if (!NUMBER.test(text)) continue;
        var host = node.parentElement && node.parentElement.closest('[data-lens-ref],[data-lens-derived]');
        if (!host) found.push(text.trim().slice(0, 40));
      }
    });
    return found;
  }
  var note = null, writes = new MutationObserver(function () {});
  function keep(html) {
    if (!note) { note = document.createElement('div'); note.id = 'lens-view-note'; root.insertAdjacentElement('afterend', note); }
    note.innerHTML = html;
  }
  function render() {
    if (!drawFn || !received) return;
    try {
      derived = [];
      writes.observe(root, { childList: true, subtree: true });
      var out;
      try { out = drawFn(lens.data, lens); } finally { var drewInPlace = writes.takeRecords().length > 0; writes.disconnect(); }
      if (typeof out === 'string') { if (drewInPlace) keep(out); else root.innerHTML = out; }
      post('lens:drawn', Object.assign({ height: Math.ceil(document.documentElement.scrollHeight), unsourced: unsourced(), derived: derived }, snapshot && !root.querySelector('canvas') ? { html: root.innerHTML } : {}));
    } catch (error) { fail(error); }
  }
  var lens = {
    data: {},
    state: {},
    draw: function (fn) { drawFn = fn; render(); },
    format: function (value, measure) {
      if (typeof value === 'string' && /^\d{4}-\d{2}$/.test(value)) return MONTHS[Number(value.slice(5)) - 1] + ' ' + value.slice(0, 4);
      if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
        var day = new Date(value.slice(0, 10) + 'T00:00:00Z');
        return measure === 'month' ? day.toLocaleDateString('en-AU', { month: 'short', timeZone: 'UTC' }) : day.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', timeZone: 'UTC' });
      }
      var known = formatted[measure];
      if (known && Object.prototype.hasOwnProperty.call(known, String(value))) return known[String(value)];
      if (value === null || value === undefined || !isFinite(value)) return '–';
      var kind = FORMAT_NAMES[measure] ? measure : (formats[measure] || {}).format;
      if (kind) return byFormat(Number(value), kind);
      return Number(value).toLocaleString('en-AU', { maximumFractionDigits: 1 });
    },
    set: function (name, value) { post('lens:set', { name: String(name), value: String(value) }); },
    select: function (column, value) { post('lens:select', { column: String(column), value: String(value) }); },
    derive: function (name, inputs, fn) { var value = fn.apply(null, inputs); derived.push({ name: String(name), inputs: inputs.map(String), formula: String(fn) }); return value; },
    scale: function (values, range) {
      var low = range ? range[0] : 0, high = range ? range[1] : 100;
      var numbers = values.map(function (value) { return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value) ? Date.parse(value) : Number(value); });
      var min = Math.min.apply(null, numbers), max = Math.max.apply(null, numbers), span = max - min || 1;
      return function (value) { var n = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value) ? Date.parse(value) : Number(value); return low + ((n - min) / span) * (high - low); };
    },
    escape: function (value) { var node = document.createElement('span'); node.textContent = value == null ? '' : String(value); return node.innerHTML; },
    kit: {
      palette: [],
      tones: {},
      figure: function (spec) {
        var change = spec.before === undefined || spec.before === null ? '' : lens.kit.delta(spec.value, spec.before, spec.measure, spec.ref);
        return '<div class="k-fig"><span class="k-label">' + lens.escape(spec.label) + '</span><span class="k-value"' + (spec.ref ? ' data-lens-ref="' + lens.escape(spec.ref) + '"' : '') + '>' + lens.escape(lens.format(spec.value, spec.measure)) + '</span>' + change + '</div>';
      },
      delta: function (now, before, measure, ref) {
        if (now === null || before === null || now === undefined || before === undefined || !isFinite(now) || !isFinite(before)) return '';
        var info = formats[measure] || {};
        var points = info.format === 'pct';
        var change = points ? (now - before) * 100 : before === 0 ? null : (now - before) / Math.abs(before) * 100;
        if (change === null) return '';
        var good = info.lowerIsBetter ? change < 0 : change > 0;
        var text = (change > 0 ? '▲ ' : change < 0 ? '▼ ' : '■ ') + Math.abs(change).toFixed(Math.abs(change) < 10 ? 1 : 0) + (points ? ' pts' : '%');
        return '<span class="k-delta ' + (change === 0 ? '' : good ? 'up' : 'down') + '" data-lens-derived="' + lens.escape((ref || measure) + ' change') + '">' + text + '</span>';
      },
      spark: function (values, size) {
        var width = (size && size.width) || 96, height = (size && size.height) || 24;
        var numbers = values.map(Number).filter(function (value) { return isFinite(value); });
        if (numbers.length < 2) return '';
        var min = Math.min.apply(null, numbers), max = Math.max.apply(null, numbers), span = max - min || 1;
        var points = numbers.map(function (value, index) { return (index / (numbers.length - 1) * width).toFixed(1) + ',' + (height - 2 - (value - min) / span * (height - 4)).toFixed(1); }).join(' ');
        return '<svg class="k-spark" width="' + width + '" height="' + height + '" viewBox="0 0 ' + width + ' ' + height + '" aria-hidden="true"><polyline points="' + points + '" fill="none" stroke="' + (lens.kit.palette[0] || 'currentColor') + '" stroke-width="1.5" stroke-linejoin="round"/></svg>';
      }
    }
  };
  window.lens = lens;
  window.addEventListener('error', function (event) { fail(event.error || event.message); });
  window.addEventListener('message', function (event) {
    if (event.source !== window.parent || !event.data || event.data.channel !== channel || event.data.type !== 'lens:data') return;
    lens.data = event.data.data; lens.state = event.data.state; formatted = event.data.formatted; formats = event.data.formats || {}; snapshot = Boolean(event.data.snapshot); received = true;
    var theme = event.data.theme || {};
    Object.keys(theme.tokens || {}).forEach(function (name) { if (theme.tokens[name]) document.documentElement.style.setProperty(name, theme.tokens[name]); });
    document.documentElement.style.colorScheme = theme.scheme || 'light';
    lens.kit.palette = theme.palette || [];
    lens.kit.tones = { good: (theme.tokens || {})['--pos'], bad: (theme.tokens || {})['--neg'], muted: (theme.tokens || {})['--muted'], ink: (theme.tokens || {})['--ink'], ink3: (theme.tokens || {})['--ink-3'] };
    render();
  });
  post('lens:ready');
})();`;

const escapeScriptEnd = (value: string) => value.replace(/<\/script/gi, '<\\/script');

export function buildViewDocument(view: LensView, channel: string, library = ''): string {
  return `<!doctype html><html><head><meta charset="utf-8"><meta http-equiv="Content-Security-Policy" content="${VIEW_CSP}"><style>${KIT_CSS}${view.css ?? ''}</style></head><body><div id="lens-view">${view.html ?? ''}</div>${library ? `<script>${escapeScriptEnd(library)}</script>` : ''}<script data-channel="${channel}">${escapeScriptEnd(RUNTIME)}</script><script>${escapeScriptEnd(view.js ?? '')}</script></body></html>`;
}
